import { formattedDate } from '@shared/utils/helpers/date-formatter'

import { AnnouncementNotification } from '@protos/announcement_notification_pb'

export class AnnouncementNotificationData extends AnnouncementNotification {
  get formattedSentAt(): string {
    if (!this.sentAt) {
      return '-'
    }

    return formattedDate(this.sentAt)
  }
  // get formattedReadAt(): string {
  //   if (!this.readAt) {
  //     return '-'
  //   }
  //
  //   return getDateTimeString({
  //     date: this.readAt,
  //     formatPattern: 'MM/DD/YY hh:mma',
  //   })
  // }
}
